export default "__VITE_ASSET__CzIGuCp0__"